<template>
    <div class="col-info pl-3">
        <a :href="'/events/'+this.data.id">
            <h4>{{ this.data.name }}</h4>
        </a>
        <div class="description">
            <i class="far fa-map-marker-alt mr-2"></i> {{ this.data.address1 }}, {{ this.data.city }}, {{ this.data.state.name }}
        </div>
    </div>
</template>

<script>
    export default {
        name: "DatatableColTitle",

        props: {
            data: {},
            name: {},
            click: {},
            meta: {},
            classes: {},
        },
    }
</script>

<style scoped>

</style>
